import { Center, ConditionalRendering, Loader } from "@marketplace/ui";
import clsx from "clsx";

import { LampuSellerLogo } from "@/assets/logo/lampu-seller-logo";

import classes from "./sidebar.module.css";
import type { SidebarMenuProps } from "./sidebar.types";
import { SidebarMenu } from "./sidebar-menu";

export const Sidebar = ({ menuItems, loading }: SidebarMenuProps) => {
  return (
    <aside
      className={clsx(
        classes.sidebar,
        "flex flex-col h-screen shrink-0 overflow-y-auto"
      )}
    >
      <div className="p-[6px]">
        <LampuSellerLogo />
      </div>

      <ConditionalRendering condition={loading}>
        <Center>
          <Loader size="sm" />
        </Center>
      </ConditionalRendering>

      <ConditionalRendering condition={!loading}>
        <SidebarMenu menuItems={menuItems} />
      </ConditionalRendering>
    </aside>
  );
};
